import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

const baseString = 'vra-value-with-header';
const ValueWithHeader = ({
  className,
  header,
  inverted=true,
  subheader,
  value,
  nestedBadge
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${baseString}--inverted`]: inverted,
    [`${className}`]: !!className
  });
  subheader = subheader ? (
    <span className={`${baseString}__subheader`} data-test-id={`vra-subheader`}>
      {subheader}
    </span>
  ) : null;

  return (
    <section className={classString}>
      <header className={`${baseString}__header`} data-test-id={`vra-header`}>
        {header}
        {subheader}
      </header>
      <div className={`${baseString}__value`} data-test-id={`vra-value`}>
        {value}
        {nestedBadge ? nestedBadge : null}
      </div>
    </section>
  );
};
ValueWithHeader.propTypes = {
  className: propTypes.string,
  header: propTypes.string,
  inverted: propTypes.bool,
  nestedBadge: propTypes.object,
  subheader: propTypes.string,
  testId: propTypes.string,
  value: propTypes.oneOfType([propTypes.number, propTypes.string, propTypes.object]).isRequired
};
export default ValueWithHeader;
